export enum TransformOriginHorizontal {
  LEFT = "left",
  RIGHT = "right",
}
